export interface MailboxEmail {
  id: string;
  conversationId: string;
  subject: string;
  fromName: string;
  fromEmail: string;
  senderRole: string;
  body: string;
  preview: string;
  sentAt: string;
  /** Timestamp pour le tri (plus récent en premier). */
  sentAtMs: number;
  isRead: boolean;
  isFromMe: boolean;
  replyToName?: string;
  replyToEmail?: string;
  senderUserId?: number;
  recipientUserId?: number;
}

export function sortEmailsNewestFirst(emails: MailboxEmail[]): MailboxEmail[] {
  return [...emails].sort((a, b) => b.sentAtMs - a.sentAtMs);
}

export function formatMailboxDate(date: Date = new Date()): string {
  return date.toLocaleString("fr-FR", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
